module.exports = __webpack_public_path__ + "d622f975cf9e817cac60a546328cb855.png";